/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {assignOONCustomerToVoiceCase} from '../api'

export const useMutationAssignOONCustomerToVoiceCase = createReactQueryMutationHook('assignOONCustomerToVoiceCase', assignOONCustomerToVoiceCase)
